import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";

export class Timbrature {
    static defragStrisciata = (timbrature: CoppiaTimbrature[], scartaSeUguali: boolean = true) => {
        const newTimbrature = [];
        for (let indE = 0; indE < timbrature.length; ++indE) {
            if (CoppiaTimbrature.isValidOne(timbrature[indE])) {
                const e = CoppiaTimbrature.getEntrata(timbrature[indE]);
                const u = CoppiaTimbrature.getUscita(timbrature[indE]);
                if (e !== u || !scartaSeUguali) {
                    // N.B. Uso factory per normalizzare entrata e uscita a '0000' se stringa vuota
                    // In AngularJS lo si faceva per tipizzare l'oggetto post edit...
                    newTimbrature.push(CoppiaTimbrature.factory(timbrature[indE]));
                }
            }
        }
        return newTimbrature;
    };

    /**
     * Analizza la striscia restituendo un oggetto con l'esito dell'analisi:
     * numero delle timb in entrata, numero delle timb in uscita, numero delle copie (incluse quelle parzialmente valide), validita (tutte le copie sono valide!)
     * @param timbrature
     * @returns {{numEntrate: number, numUscite: number, contaCopie: number, isValid: (function(): boolean)}}
     */
    static analizzaStrisciata = (timbrature: CoppiaTimbrature[]) => {
        let numEntrate = 0;
        let numUscite = 0;
        for (let indE = 0; indE < timbrature.length; ++indE) {
            /*if (!angular.isFunction(timbrature[indE].getEntrata)) {
                // Normalizzo oggetto a seguito di new data entry
                timbrature[indE] = TurnoDistribuzione$CopiaTimbrature.factory(timbrature[indE]);
            }*/
            numEntrate += (CoppiaTimbrature.getEntrata(timbrature[indE]) !== null ? 1 : 0);
            numUscite += (CoppiaTimbrature.getUscita(timbrature[indE]) !== null ? 1 : 0);
        }

        let contaCoppie = 0;
        for (let indE = 0; indE < timbrature.length; ++indE) {
            contaCoppie += CoppiaTimbrature.isValidOne(timbrature[indE]) ? 1 : 0;
        }
        return {
            numEntrate,
            numUscite,
            contaCoppie,
            isValid: function () {
                return ((numEntrate + numUscite) === contaCoppie * 2);
            }
        };
    };

    /**
     * target: es day.arrotondate
     * coppia: istanza di <Coppia>
     */
    static addCoppia(target: CoppiaTimbrature[], coppia: Coppia) {
        if (coppia !== null) {
            var newCoppia = CoppiaTimbrature.factory();
            CoppiaTimbrature.setEntrata(newCoppia, coppia.getInizio());
            CoppiaTimbrature.setUscita(newCoppia, coppia.getFine());
            target.push(newCoppia);
        }
    }

    static impostaPausa(timbrature: CoppiaTimbrature[], distribuzione: TurnoDistribuzioneRecord, setMax: boolean = false) {
        let minutiPausa = 0;
        if (setMax) {
            switch (distribuzione.azionePerPausaSenzaTimbrature) {
                case 'DECURTA_MIN_PAUSA':
                    minutiPausa = distribuzione.minMinutiPausa;
                    break;
                case 'DECURTA_MAX_PAUSA':
                    minutiPausa = distribuzione.maxMinutiPausa;
                    break;
                case 'NESSUNA_OPERAZIONE':
                    break;
            }
        } else {
            minutiPausa = distribuzione.minMinutiPausa;
        }

        if (minutiPausa > 0 && distribuzione.decurtaPausa) {
            const timbratureTemp: CoppiaTimbrature[] = [];
            const copia = CoppiaTimbrature.factory();
            CoppiaTimbrature.setEntrata(copia, CoppiaTimbrature.getEntrata(timbrature[0]));
            CoppiaTimbrature.setUscita(copia, CoppiaTimbrature.getUscita(timbrature[0]));
            timbratureTemp.push(copia);

            const uscita = CoppiaTimbrature.getUscita(timbratureTemp[0]);
            CoppiaTimbrature.setUscita(timbratureTemp[0], CoppiaTimbrature.getEntrata(distribuzione.pausa));
            timbratureTemp.push(CoppiaTimbrature.factory());
            const hhccDurata = (minutiPausa / 60) * 100.0;
            let hhccEntrata = Calc.hhmm2hhcc(CoppiaTimbrature.getEntrata(distribuzione.pausa));
            hhccEntrata += hhccDurata;
            CoppiaTimbrature.setEntrata(timbratureTemp[1], Calc.hhcc2hhmm(hhccEntrata));
            CoppiaTimbrature.setUscita(timbratureTemp[1], uscita);
            return timbratureTemp;
        } else {
            return timbrature;
        }
    }
}